import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';
import './index.less';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      className="custom-footer"
      style={{
        background: 'none',
      }}
      copyright="Powered by Money Fellows Limited"
      links={[
        {
          key: 'Money Fellows Limited',
          title: 'Money Fellows Limited',
          href: 'https://moneyfellows.com',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
